document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('price-per-item')) {
    customElements.define(
      'price-per-item',
      class PricePerItem extends HTMLElement {
        constructor() {
          super();
          this.variantId = this.dataset.variantId;
          this.input = document.getElementById(`Quantity-${this.dataset.sectionId || this.dataset.variantId}`);
          if (this.input) {
            this.input.addEventListener('change', this.onInputChange.bind(this));
          }
          this.getVolumePricingArray();
        }

        updatePricePerItemUnsubscriber = undefined;
        variantIdChangedUnsubscriber = undefined;

        connectedCallback() {
          this.getVolumePricingArray();
          this.updatePricePerItem();

          try {
            this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.variantId = event.data.variant.id.toString();
              this.getVolumePricingArray();
              this.updatePricePerItem();
            });
          } catch (e) {
            console.warn('Variant pub-sub not available:', e);
          }

          try {
            this.updatePricePerItemUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (response) => {
              if (!response.cartData) return;

              const variantMatch = response.cartData.items?.find((item) => item.variant_id.toString() === this.variantId);

              if (response.cartData['variant_id'] !== undefined) {
                if (response.productVariantId === this.variantId) this.updatePricePerItem(response.cartData.quantity);
              } else if (response.cartData.item_count !== 0 && variantMatch) {
                this.updatePricePerItem(variantMatch.quantity);
              } else {
                this.updatePricePerItem(0);
              }
            });
          } catch (e) {
            console.warn('Cart pub-sub not available:', e);
          }
        }

        disconnectedCallback() {
          if (this.updatePricePerItemUnsubscriber) this.updatePricePerItemUnsubscriber();
          if (this.variantIdChangedUnsubscriber) this.variantIdChangedUnsubscriber();
        }

        onInputChange() {
          this.updatePricePerItem();
        }

        updatePricePerItem(updatedCartQuantity) {
          if (!this.input) return;
          this.enteredQty = parseInt(this.input.value || '0');
          this.step = parseInt(this.input.step || '1');

          this.currentQtyForVolumePricing = updatedCartQuantity === undefined
            ? this.getCartQuantity(updatedCartQuantity) + this.enteredQty
            : this.getCartQuantity(updatedCartQuantity) + this.step;

          if (this.classList.contains('variant-item__price-per-item')) {
            this.currentQtyForVolumePricing = this.getCartQuantity(updatedCartQuantity);
          }

          for (let pair of this.qtyPricePairs) {
            if (this.currentQtyForVolumePricing >= pair[0]) {
              const priceSpan = this.querySelector('.price-per-item span');
              if (priceSpan) {
                priceSpan.innerHTML = pair[1];
              }
              break;
            }
          }
        }

        getCartQuantity(updatedCartQuantity) {
          if (!this.input || !this.input.dataset.cartQuantity) return 0;
          return (updatedCartQuantity || updatedCartQuantity === 0)
            ? updatedCartQuantity
            : parseInt(this.input.dataset.cartQuantity);
        }

        getVolumePricingArray() {
          const volumePricing = document.getElementById(`Volume-${this.dataset.sectionId || this.dataset.variantId}`);
          this.qtyPricePairs = [];

          if (volumePricing) {
            volumePricing.querySelectorAll('li').forEach(li => {
              const qty = parseInt(li.querySelector('span:first-child')?.textContent || '0');
              const price = li.querySelector('span:not(:first-child):last-child')?.dataset?.text || '';
              if (qty && price) this.qtyPricePairs.push([qty, price]);
            });
          }

          this.qtyPricePairs.reverse();
        }
      }
    );
  }
});
